import {EtatEnum} from "@resources/resources";

export class EtatEnums {

  private static _en_cours: EtatEnum = 'EN_COURS';
  private static _termine: EtatEnum = 'TERMINE';
  private static _en_attente: EtatEnum = 'EN_ATTENTE';
  private static _a_valider: EtatEnum = 'A_VALIDER';

  static EN_COURS = new EtatEnums(EtatEnums._en_cours);
  static TERMINE = new EtatEnums(EtatEnums._termine);
  static EN_ATTENTE = new EtatEnums(EtatEnums._en_attente);
  static A_VALIDER = new EtatEnums(EtatEnums._a_valider);


  private static _values = [
    EtatEnums.EN_COURS.value(),
    EtatEnums.TERMINE.value(),
    EtatEnums.EN_ATTENTE.value(),
    EtatEnums.A_VALIDER.value(),
  ];

  constructor(public str: EtatEnum) {
  }

  value(): EtatEnum {
    return this.str;
  }

  static values(): Array<EtatEnum> {
    return this._values;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/enum/Etat.enum.ts